import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- master Inventory Apis ------------------------------
export const getInventoryFields = createAsyncThunk(
    "getInventoryFields",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getInventoryFields, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const addInventoryField = createAsyncThunk(
    "addInventoryField",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addInventoryField, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateInventoryField = createAsyncThunk(
    "updateInventoryField",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateInventoryField, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getInventoryFieldById = createAsyncThunk(
    "getInventoryFieldById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getInventoryFieldById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const deleteInventoryField = createAsyncThunk(
    "deleteInventoryField",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.deleteInventoryField + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

//----------------- Inventory APis ------------------------
export const getInventories = createAsyncThunk(
    "getInventories",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getInventories, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const addInventory = createAsyncThunk(
    "addInventory",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addInventory, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateInventory = createAsyncThunk(
    "updateInventory",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateInventory, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const getInventoryById = createAsyncThunk(
    "getInventoryById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getInventoryById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const deleteInventory = createAsyncThunk(
    "deleteInventory",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.deleteInventory + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const getAllItemName = createAsyncThunk(
    "getAllItemName",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getAllItemName, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getAllItemsByCategory = createAsyncThunk(
    "getAllItemsByCategory",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getAllItemsByCategory, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const createProduct = createAsyncThunk(
    "createProduct",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.createProduct, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const deleteProduct = createAsyncThunk(
    "deleteProduct",
    async (idPath) => {
        return ApiPostNoAuth(BaseUrl, `${api.deleteProduct}${idPath || ""}`)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);



export const getProducts = createAsyncThunk(
    "getProductData",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getProductData, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const getProductById = createAsyncThunk(
    "getProductById",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getProductById, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);